import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/donations/receipts";

export const Route = createFileRoute("/admin/_donations/receipts")({
  component: Page,
});
